import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import moment from 'moment';
import ExcelReader from 'components/common/FileController/ExcelReader';
import CenterOptionList from 'components/common/CommonComponent/CenterOptionList';
import { notification, Table, Pagination, Button, Input, Select, Tooltip, ConfigProvider, DatePicker, Modal, Tag } from 'antd';

import koKr from 'antd/es/locale/ko_KR';
import 'moment/locale/ko';
moment.locale('ko');

@inject('orderReturnStore')
@observer
class ReturnList extends Component {
  state = {
    orGdNm: '',
    orUserId: '',
    orUserNm: '',

    // 상태변경 모달
    modalVisible: false,
    changStat: "",
    selectData: null,
    // 반려사유 입력
    rejectReason: '',
  };

  onPageChange = (pageIdx) => {
    // console.log('page:', page);
    this.props.orderReturnStore.disReturnList(pageIdx);
  };

  onSearch = () => {
    this.props.orderReturnStore.onChangValue('orUserId', this.state.orUserId);
    this.props.orderReturnStore.onChangValue('orUserNm', this.state.orUserNm);
    this.props.orderReturnStore.onChangValue('orGdNm', this.state.orGdNm);
    this.props.orderReturnStore.disReturnList(1);
  };

  onPressEnter = (e) => {
    if (e.key === 'Enter') {
      this.onSearch();
    }
  };

  render() {
    const {
      valCondition,
      returnList,
      pageInfo,
      onChangValue,

      disReturnList,
      appReturnInfo,
      rejectReturnInfo
    } = this.props.orderReturnStore;
    const {
      orGdNm,
      orUserId,
      orUserNm,

      modalVisible,
      changStat,
      selectData,
      rejectReason,
    } = this.state;
    const columns = [
      { title: 'No', dataIndex: 'RNUM', width: 70, align: 'center' },
      { title: '주문일', dataIndex: 'orDate', width: 140, align: 'center',
        render: (item, record) => { return(
          moment(item).format('YYYY-MM-DD')
        )}
      },
      { title: '주문번호', dataIndex: 'orCartNo', width: 250, align: 'reft',
        render: (item, record) => { return(
          <Fragment>
            <span style={{ marginRight: 5 }}>{item}</span>
            {record.exceptionYn !== undefined && record.exceptionYn !== null && record.exceptionYn === "Y"
            && <Tag color="blue">기준외주문</Tag>}
          </Fragment>
        )}
      },
      { title: '주문상태', dataIndex: 'orStat', width: 300, align: 'center',
        render: (item, record) => { 
          return record.orStat === "7" ? (
          <Fragment>
            반품수량:  
            {record.rtCnt !== undefined && record.rtCnt !== null && record.rtCnt} 건
            <Button
              style={{ margin: 8 }}
              onClick={()=>this.setState({ modalVisible: true, selectData: record, changStat: "8" })}
            >반품승인</Button>
            <Button
              onClick={()=>this.setState({ modalVisible: true, selectData: record, rejectReason: "", changStat: "9" })}
            >반품반려</Button>
          </Fragment>
          ) : (
            <Fragment>
              {item === "8" && <Fragment>반품승인</Fragment>}
              {(item === "9") &&
              ((record.rejectReason !== undefined && record.rejectReason !== null && record.rejectReason !== '')
                ? <Tooltip placement="topLeft" title={record.rejectReason}>
                    <span style={{color: 'blue'}}>반품반려</span>
                  </Tooltip>
                : <Fragment>반품반려</Fragment>)
              }
            </Fragment>
          )
        }
      },
      { title: '지사', dataIndex: 'orBranchNm', width: 140, align: 'center' },
      { title: '센터', dataIndex: 'orCeNm', width: 160, align: 'center' },
      { title: '직무', dataIndex: 'orJobNm', width: 150, align: 'center' },
      { title: '성별', dataIndex: 'userSex', width: 80, align: 'center',
        render: (item, record) => { return(
          <Fragment>
            {item === "M" && <Fragment>남</Fragment>}
            {item === "F" && <Fragment>여</Fragment>}
          </Fragment>
        )}
      },
      { title: '사번', dataIndex: 'userId', width: 120, align: 'center' },
      { title: '사원명', dataIndex: 'userNm', width: 150, align: 'center'},
      { title: '상품명', dataIndex: 'gdNm', width: 250, align: 'center' },
      { title: '사이즈', dataIndex: 'orGdSize', width: 100, align: 'center',
        render: (item, record, index) => { return(
          item === "기타"
          ? <Tooltip placement="topLeft" title={record.orEtc}>
              <span style={{color: 'blue'}}>{item}</span>
            </Tooltip>
          : item
        )}
      },
      { title: '주문수량', dataIndex: 'orCnt', width: 100, align: 'center' },
      { title: '금액', dataIndex: 'orGdPrice', width: 130, align: 'center',
        render: (item, record) => { return(
          <Fragment>
            {item !== undefined && item !== null && item !== '' &&
            (parseInt(item)*parseInt(record.orCnt)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          </Fragment>
        )}
      },
      // { title: '신청사유', dataIndex: 'reqReason', width: 130, align: 'center',
      //   render: (item, record, index) => { 
      //     return (
      //       item !== undefined && item !== null && item !== "" &&
      //       <Tooltip placement="topLeft" title={record.reqReason}>
      //         <span style={{color: 'blue'}}>신청사유</span>
      //       </Tooltip>
      //     )
      //   },
      // },
      { title: '반품사유', dataIndex: 'returnReason', width: 130, align: 'center',
        render: (item, record, index) => { 
          return (
            <Tooltip placement="topLeft" title={record.returnReason}>
              <span style={{color: 'blue'}}>반품사유</span>
            </Tooltip>
          )
        },
      },
    ];
    return (
      <Fragment>
        <div className="search-box mo_srch_box">
          <div className="search-content" style={{float:'left'}}>
            <span className="mo_srch">
              <span className="labal2">주문기간</span>
              <ConfigProvider locale={koKr}>
                <DatePicker.RangePicker
                  style={{ width: 270, marginRight: '20px' }}
                  format={'YYYY-MM-DD'}
                  allowClear={false}
                  defaultValue={[
                    moment(moment().subtract(1, 'month').format('YYYY-MM-DD').toString(), 'YYYY-MM-DD'), 
                    moment(moment().format('YYYY-MM-DD').toString(), 'YYYY-MM-DD')
                  ]}
                  onChange={(date)=>{
                    onChangValue('strDate', date[0].format('YYYY-MM-DD'));
                    onChangValue('endDate', date[1].format('YYYY-MM-DD'));
                    this.onSearch();
                  }}
                />
              </ConfigProvider>
            </span>
            <span className="mo_srch">
              <span className="labal2">주문상태</span>
              <Select
                style={{ width: 150, marginRight: '20px' }}
                value={valCondition.orStat}
                onChange={(value)=>{
                  onChangValue('orStat', value);
                  this.onSearch();
                }}
              >
                <Select.Option key={''}>전체</Select.Option>
                <Select.Option key={'7'}>반품신청</Select.Option>
                <Select.Option key={'8'}>반품승인</Select.Option>
                <Select.Option key={'9'}>반품반려</Select.Option>
              </Select>
            </span>
            <span className="mo_srch">
              <span className="labal2">상품명</span>
              <Input 
                placeholder="상품명을 입력하세요"
                value={orGdNm}
                onChange={(e)=>this.setState({orGdNm: e.target.value})}
                onPressEnter={this.onPressEnter}
                style={{ width: 200 }}
              />
            </span>
          </div>
          <br />
          <div className="search-content" style={{float:'left'}}>
            <CenterOptionList
              ceBranchCdValue={valCondition.ceBranchCd}
              ceCdValue={valCondition.ceCd}
              eBranchCdChange={(value)=>{
                onChangValue('ceBranchCd', value);
                onChangValue('ceCd', '');
                this.onSearch();
              }}
              ceCdfuncChange={(value)=>{
                onChangValue('ceCd', value);
                this.onSearch();
              }}
            />
            <span className="mo_srch">
              <span className="labal2">사번</span>
              <Input 
                placeholder="사번을 입력하세요"
                value={orUserId}
                onChange={(e)=>this.setState({orUserId: e.target.value})}
                onPressEnter={this.onPressEnter}
                style={{ width: 200 }}
              />
            </span>
            <span className="mo_srch">
              <span className="labal2">사원명</span>
              <Input 
                placeholder="사원명을 입력하세요"
                value={orUserNm}
                onChange={(e)=>this.setState({orUserNm: e.target.value})}
                onPressEnter={this.onPressEnter}
                style={{ width: 200 }}
              />
            </span>
          </div>
          <div className="search-button">
            <Button type="primary" onClick={this.onSearch}>조회</Button>
          </div>
        </div>

        <div className="button-group">
          <Select
            style={{ width: 120 }}
            value={valCondition.recordCountPerPage}
            onChange={(value)=>disReturnList(1, value)}
          >
            <Select.Option value={10}>10개 보기</Select.Option>
            <Select.Option value={20}>20개 보기</Select.Option>
            <Select.Option value={30}>30개 보기</Select.Option>
            <Select.Option value={40}>40개 보기</Select.Option>
          </Select>
          <div className="button-right">
            <ul>
              <li>
                {/* 엑셀다운로드 */}
                <ExcelReader
                  actionType={'download'}
                  pageUrl={'DOWN-RETURN-LIST'}
                  schInfo={valCondition}
                />
              </li>
            </ul>
          </div>
        </div>

        <Table
          rowKey={(record)=>record.RNUM}
          rowClassName={(record)=>
            (record.orCnt !== undefined && record.orCnt !== null && parseInt(record.orCnt) < 0 && "red")
          }
          columns={columns} 
          dataSource={returnList}
          pagination={false}
          scroll={{ x: 2270 }}
        />
        <br />
        <div className="page_nav_ct">
          <Pagination
            showSizeChanger={false}
            current={pageInfo !== null ? pageInfo.pageIndex : 1}
            total={pageInfo !== null ? pageInfo.totalCnt : 0}
            pageSize={pageInfo !== null ? pageInfo.recordCountPerPage : 0}
            onChange={this.onPageChange}
          />
        </div>

        {/* 상태변경 모달 */}
        <Modal
          width={600}
          title={ (changStat === "8") ? "승인하기"
                : (changStat === "9") ? "반려하기"
                : ""
          }
          cancelText={"취소"}
          okText={"확인"}
          closable={false}
          visible={modalVisible}
          onCancel={()=>this.setState({ modalVisible: false })}
          onOk={()=>{
            if (selectData === null) {
              notification.warning({placement: 'bottomLeft', message: `선택정보가 없습니다.`, duration: 2});
              this.setState({ modalVisible: false });
              return;
            }
            if (changStat === "8") {
              appReturnInfo({...selectData, orStat: changStat});
            } else if (changStat === "9") {
              if (rejectReason === "") {
                notification.warning({placement: 'bottomLeft', message: `사유를 입력해주세요.`, duration: 2});
                return;
              }
              rejectReturnInfo({...selectData, rejectReason: rejectReason, orStat: changStat});
            }
            
            this.setState({ modalVisible: false });
          }}
        >
          {selectData !== null && // "승인하기"
            <Fragment>
              <table className="table_st_wrap">
                <tbody>
                  <tr><th>사번</th><td>{selectData.userId}</td></tr>
                  <tr><th>사원명</th><td>{selectData.userNm}</td></tr>
                  <tr><th>총 건수</th><td>{selectData.orCnt}</td></tr>
                  <tr>
                    <th>총 주문액</th>
                    <td>
                      {selectData.totalPrice !== undefined && selectData.totalPrice !== null &&
                      selectData.totalPrice !== "" && selectData.totalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    </td>
                  </tr>
                  {changStat === "9" &&
                  <tr>
                    <th>반려사유</th>
                    <td>
                      <Input 
                        placeholder="사유를 입력하세요"
                        value={rejectReason}
                        onChange={(e)=>this.setState({rejectReason: e.target.value})}
                        style={{ width: '100%'}}
                      />
                    </td>
                  </tr>
                  }
                </tbody>
              </table>
              <div className="last_chk_text">
                {changStat === "8" && <b>반품을 승인하시겠습니까?</b>}
                {changStat === "9" && <b>반품을 반려하시겠습니까?</b>}
              </div>
            </Fragment>
          }

        </Modal>
      </Fragment>
    );
  }

}

export default withRouter(ReturnList);
